
import { overrideStore, parametrize } from 'react-overridable';

import ParticlesResultsListItem from '@js/particles/search/ResultsListItem';
import { RecordsList } from '@js/oarepo_ui/search/RecordsList';
import FramResultsListItem from '@js/fram/search/ResultsListItem';
import DetectorsResultsListItem from '@js/detectors/search/ResultsListItem';
import Atlas_itkResultsListItem from '@js/atlas_itk/search/ResultsListItem';
const RecordsListWithProps = parametrize(RecordsList, { searchEndpoint: "/search" });

overrideStore.add('InvenioAppRDM.RecordsList.ResultsList.item.local://particles-v1.0.0.json', ParticlesResultsListItem);
overrideStore.add('InvenioAppRDM.RecordsList.layout', RecordsListWithProps);
overrideStore.add('InvenioAppRDM.RecordsList.ResultsList.item.local://fram-v1.0.0.json', FramResultsListItem);
overrideStore.add('InvenioAppRDM.RecordsList.ResultsList.item.local://detectors-v1.0.0.json', DetectorsResultsListItem);
overrideStore.add('InvenioAppRDM.RecordsList.ResultsList.item.local://atlas_itk-v1.0.0.json', Atlas_itkResultsListItem);
